import { Text } from 'recharts'

import { GRAY_COLORS } from 'asterX-UI'

function CustomTickY({ x, y, payload }) {
  return (
    <Text
      x={x}
      y={y}
      fill={GRAY_COLORS[75]}
      fontSize={12}
      textAnchor="middle"
      dx={-12}
    >
      {payload.value}
    </Text>
  )
}

export default CustomTickY
